/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgProblem = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M8.889 20.5h6.222L20 15.611V9.39L15.111 4.5H8.89L4 9.389v6.222zm5.6-1.5 4.011-4.01v-4.98L14.49 6H9.51L5.5 10.01v4.98L9.51 19z" clipRule="evenodd" /><path fill="currentColor" d="M11 8h2l-.25 6h-1.5zM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2" /></svg>;
export default SvgProblem;